import React from "react";
import FontAwesome from "react-fontawesome";
import { Dropdown, Row, Col } from "react-bootstrap";
import lowScoreIcon from "resources/images/dynamic_score_reports/aptitude/score-report/aptitude-low-score-icon.png";
import midScoreIcon from "resources/images/dynamic_score_reports/aptitude/score-report/aptitude-mid-score-icon.png";
import highScoreIcon from "resources/images/dynamic_score_reports/aptitude/score-report/aptitude-high-score-icon.png";

export const getResultsDetailsText = (candidateInfo, rawScore, percentile) => {
  const firstName = candidateInfo.get("testTakerFirstName");
  const lastName = candidateInfo.get("testTakerLastName");

  return (
    <Row className="pb-3">
      <p>
        {`
      ${firstName} ${lastName} achieved an overall score of ${rawScore}, which means ${firstName} answered
      ${rawScore} questions correctly. This corresponds to a percentile rank of ${percentile}, meaning ${firstName} scored
      better than ${percentile}% of the people who have taken this test. Below are details of how ${firstName} performed
      in specific subcategories.
      `}
      </p>
    </Row>
  );
};

// Might need have to add a helper function to pull the correct high,mid, and low icons for each testType
export const getBellCurveExplanation = () => (
  <Row>
    <div>
      <h3 className="reportHeader">Score Explanation</h3>
      <div className="row mt-3">
        <div className="col">
          <div className="row">
            <div className="col-2">
              <img
                src={highScoreIcon}
                alt="High range scores"
                width="64"
                height="64"
              />
            </div>
            <div className="col-10">
              <h5 className="sr-h5">
                High Range Scores (Above 80th Percentile)
              </h5>
              <p>
                People with higher test scores can generally learn and do
                mechanical jobs better than people with mid or low range scores.
                They are more likely to pick up training faster than those with
                lower scores.
              </p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-2">
              <img
                src={midScoreIcon}
                alt="Mid range scores"
                width="64"
                height="64"
              />
            </div>
            <div className="col-10">
              <h5 className="sr-h5">
                Mid-Range Scores (25th to 80th Percentile)
              </h5>
              <p>
                People with mid-range scores can generally learn and do
                mechanical jobs, but may require more training than people with
                high range scores.
              </p>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="row">
            <div className="col-2">
              <img
                src={lowScoreIcon}
                alt="Low range scores"
                width="64"
                height="64"
              />
            </div>
            <div className="col-10">
              <h5 className="sr-h5">
                Low Range Scores (Below 25th Percentile)
              </h5>
              <p>
                People with lower mechanical ability may be able to do many
                mechanical jobs, but may require more training and may take
                longer to pick up on job skills.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Row>
);

export const getScoreRangeDropdownItems = (scoreRanges, isCustom) => {
  if (!scoreRanges || scoreRanges.size === 0) {
    return null;
  }
  if (isCustom) {
    return scoreRanges
      .keySeq()
      .sort((a, b) =>
        scoreRanges
          .get(a)
          .get("name")
          .localeCompare(scoreRanges.get(b).get("name"))
      )
      .map((rangeId) => (
        <Dropdown.Item eventKey={rangeId} key={rangeId}>
          {scoreRanges.get(rangeId).get("name")}
        </Dropdown.Item>
      ));
  }

  return scoreRanges
    .keySeq()
    .sort()
    .map((rangeName) => (
      <Dropdown.Item eventKey={rangeName} key={rangeName}>
        {rangeName}
      </Dropdown.Item>
    ));
};

export const getInvalidTextElement = (testId) => {
  switch (testId) {
    case 10:
      // Maybe might pull this out of the switch if I notice that many of the invalid text match the same style
      return (
        <Row
          className="text-danger rounded border border-danger py-3 mb-3"
          style={{ backgroundColor: "#faecf1" }}
        >
          <Col lg={3} className="mt-1">
            <h2 className="font-weight-bold ml-3" style={{ fontSize: "20px" }}>
              <FontAwesome name="exclamation-triangle" className="mr-2" />{" "}
              Assessment Error
            </h2>
          </Col>
          <Col>
            This person’s unusual response pattern indicates that they have
            recently taken this same version of the CCAT. This can happen
            because of a technical problem experienced during an earlier attempt
            to take the test, or because this person took this version of the
            test while applying to another employer, or for other reasons. It is
            recommended that this test result be ignored. To obtain an accurate
            result you can administer an alternate version of the CCAT to this
            person.
          </Col>
        </Row>
      );
    default:
      return "";
  }
};
